import _ from "lodash";
import set from "@rill/set";
import React from "react";
import { CreateOrganizationComponent } from "./manage-coaches/CreateOrganizationComponent";
import { ManageCoaches } from "./manage-coaches/ManageCoachesComponent";
import { ManageCoachModalComponent } from "./manage-coaches/ManageCoachModalComponent";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";

module.exports = (app) => {
  app.get(
    "/manage-coaches",
    set("heading", "Manage Coaches"),
    (ctx, next) =>
      checkOrganizationSectionPermission(
        ctx,
        next,
        "settings",
        "/coaching-portal/settings",
        ["Owner", "Admin"]
      ),
    async ({ res, locals, load, req }) => {
      const { query = {} } = req;
      const modal = query.modal || {};
      const { activeUser } = locals;
      const { organizationId = null } = activeUser;

      await load("organizationPermissions");
      await load("organizationRoles");

      //load modal
      locals.modal = {
        "manage-coach-modal": <ManageCoachModalComponent locals={locals} />,
      }[modal.type];

      if (!!organizationId) {
        await load("usersOrganization");
        res.body = <ManageCoaches locals={locals} />;
      } else {
        res.body = <CreateOrganizationComponent locals={locals} />;
      }
    }
  );
};

//6539453384dcf8354090a4f5
